export async function initAuthRefreshToken() {
  if (await this.forceTokenRefresh()) {
    return this.initUser()
  } else {
    return null
  }
}
